import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Play, Pause, RefreshCw } from "lucide-react";
import { adminApi } from "@/lib/api";

const btn = "text-[10px] font-mono uppercase px-2 py-1 border inline-flex items-center gap-1 disabled:opacity-30";

export const MetaCampaignActions = ({ campaign }) => {
  const [meta, setMeta] = useState(campaign.meta || null);
  const [busy, setBusy] = useState(false);

  const run = async (fn, okMsg) => {
    setBusy(true);
    try {
      const r = await fn();
      setMeta((m) => ({ ...m, ...r }));
      toast.success(okMsg);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore Meta API");
    } finally { setBusy(false); }
  };

  if (!campaign.paid_at) return <span className="text-[10px] font-mono text-[#52525b]">non pagata</span>;

  if (!meta) {
    return (
      <button data-testid={`meta-create-${campaign.id}`} disabled={busy}
        onClick={() => run(() => adminApi.metaCreate(campaign.id), "Campagna creata su Meta IN PAUSA")}
        className={`${btn} border-[#3b82f6] text-[#3b82f6] hover:bg-[#3b82f6]/10`}>
        {busy && <Loader2 className="w-3 h-3 animate-spin" />} Crea su Meta (in pausa)
      </button>
    );
  }

  const active = meta.status === "ACTIVE";
  const ins = meta.insights;
  return (
    <div data-testid={`meta-actions-${campaign.id}`} className="space-y-1.5 min-w-[180px]">
      <div className="flex items-center gap-1.5">
        <span className={`text-[10px] font-mono uppercase px-1.5 py-0.5 ${active ? "bg-[#10b981] text-white" : "bg-[#f59e0b] text-black"}`}>
          {active ? "attiva" : "in pausa"}
        </span>
        {meta.simulated && <span className="text-[9px] font-mono uppercase text-[#92400e] bg-[#fef3c7] border border-[#f59e0b] px-1">simulato</span>}
      </div>
      <div className="flex gap-1">
        {active ? (
          <button data-testid={`meta-pause-${campaign.id}`} disabled={busy}
            onClick={() => run(() => adminApi.metaAction(campaign.id, "pause"), "Campagna messa in pausa")}
            className={`${btn} border-[#d5dbde] text-[#5b6168] hover:border-[#f59e0b]`}><Pause className="w-3 h-3" /> Pausa</button>
        ) : (
          <button data-testid={`meta-activate-${campaign.id}`} disabled={busy}
            onClick={() => run(() => adminApi.metaAction(campaign.id, "activate"), "Campagna ATTIVATA su Meta")}
            className={`${btn} border-[#10b981] text-[#10b981] hover:bg-[#10b981]/10`}><Play className="w-3 h-3" /> Attiva</button>
        )}
        <button data-testid={`meta-insights-${campaign.id}`} disabled={busy}
          onClick={() => run(async () => ({ insights: await adminApi.metaInsights(campaign.id) }), "Metriche aggiornate")}
          className={`${btn} border-[#d5dbde] text-[#5b6168] hover:border-[#E0262C]`}><RefreshCw className="w-3 h-3" /> Metriche</button>
      </div>
      {ins && (
        <div data-testid={`meta-insights-data-${campaign.id}`} className="text-[10px] font-mono text-[#6b7280]">
          {ins.impressions} imp · {ins.clicks} clic · €{Number(ins.spend).toFixed(0)} · {ins.conversations} chat
        </div>
      )}
    </div>
  );
};
